import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const displayVariants = cva(
	"font-display leading-[1.05] tracking-tight text-gray-900 dark:text-white",
	{
		variants: {
			size: {
				sm: "text-[15px] font-semibold",
				md: "text-lg font-semibold",
				lg: "text-2xl font-semibold tracking-[-0.025em]",
				xl: "text-4xl font-medium tracking-[-0.035em]",
			},
		},
		defaultVariants: {
			size: "md",
		},
	},
);

export interface DisplayHeadingProps
	extends React.HTMLAttributes<HTMLHeadingElement>,
		VariantProps<typeof displayVariants> {
	as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

const DisplayHeading = React.forwardRef<HTMLHeadingElement, DisplayHeadingProps>(
	({ className, size, as: Tag = "h2", ...props }, ref) => {
		return (
			<Tag
				ref={ref}
				className={cn(displayVariants({ size, className }))}
				{...props}
			/>
		);
	},
);
DisplayHeading.displayName = "DisplayHeading";

export { DisplayHeading, displayVariants };
